import { useDispatch } from 'react-redux'
import { useCallback } from 'react'
import { notificationShow as actionNotificationShow } from 'modules/Notifications/actions'

export const useNotifications = () => {
  const dispatch = useDispatch()

  const notificationShow = useCallback(
    (props) => dispatch(actionNotificationShow(props)),
    [],
  )

  return {
    notificationShow,
  }
}
